import { useState, useEffect } from 'react';

const getMatches = (query) =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia(query).matches
        : false;

// Reads the real match on the first render (no false→true correction render
// on mount) and subscribes once per query instead of once per change.
export const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(() => getMatches(query));

    useEffect(() => {
        const media = window.matchMedia(query);
        const listener = (event) => setMatches(event.matches);

        // The query may have changed since the initial render, or the
        // viewport may have moved between render and subscribe.
        setMatches(media.matches);

        media.addEventListener('change', listener);
        return () => media.removeEventListener('change', listener);
    }, [query]);

    return matches;
};

export const useIsMobile = () => {
    return useMediaQuery('(max-width: 768px)');
};

// Tailwind's `md` breakpoint; the desktop sidebar exists from this width up.
export const useIsDesktop = () => {
    return useMediaQuery('(min-width: 768px)');
};
